$shm_hotkey_editor $mol_pick
	status \
	activation_label \C
	anchor \
	Bubble $mol_pop_bubble
		content /
			<= Card $mol_view
				sub <= bubble_content
		style *
			^
			positionAnchor <= anchor
	message \Нажмите клавишу или сочетание
	remove_enabled false
	remove? null
	configure? null
	sub_visible <= popup_content /$mol_view
	bubble_content /
		<= Message $mol_view
			sub / <= message
		<= Status $mol_view
			sub / <= status
		<= Configure $mol_button_minor
			title <= configure_title \
			hint <= configure_hint \
			click? <=> configure?
		<= Remove $mol_button_minor
			title \Убрать сочетание
			hint \Delete
			enabled <= remove_enabled
			click? <=> remove?
			sub /
				<= Remove_icon $mol_icon_trash_can
				\Убрать сочетание
